import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	styleUrls: [ './form.component.scss' ]
})
export class FormComponent implements OnInit {
	@Input() formFields: any;
	@Input() config: any = {};
	@Output() formObject = new EventEmitter();

	form: UntypedFormGroup;
	controlJson: any = {};

	constructor() {}

	ngOnInit(): void {}

	formObjectReader(record, groupRecord, index) {
		this.controlJson['group_' + groupRecord.fieldGroupId] = record.form;
		this.form = new UntypedFormGroup(this.controlJson);
		if (index === this.formFields.fieldGroup.length - 1) {
			this.formObject.emit({
				field: this.formFields,
				form: this.form
			});
		}
	}
}
